import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../reduxHooks';
import { fetchResumoCart, fetchResumoCartPerf, fetchPerfHist, fetchPosCon, fetchCartExp, fetchFluxoAtivos, fetchIFsCaixa, fetchEstats, fetchCarteiraList, fetchCapaPdf, } from '../api';
import { ABAS_DEFAULT } from '../preferenceStyleInterface';
export function useFechAPIs(isLoaded, loading, dispatchPDF, fluxoAtivos) {
    var _a;
    const dispatch = useAppDispatch();
    const [loadedCarteiraList, preferenceCustomizacao, preferenceLiberacao, loadedCapaPDF] = useAppSelector((state) => [
        state.preference.loadedCarteiraList,
        state.preference.preferenceStyle.customizacao,
        state.preference.preferenceStyle.liberacao,
        state.capaPDF.isLoaded,
    ]);
    const abas = (_a = preferenceLiberacao === null || preferenceLiberacao === void 0 ? void 0 : preferenceLiberacao.abas) !== null && _a !== void 0 ? _a : ABAS_DEFAULT;
    const mapeamentoFuncoes = {
        ResCart: () => fetchResumoCart(),
        PerfHist: () => fetchPerfHist(),
        PosCon: () => fetchPosCon(),
        CartExp: () => fetchCartExp(),
        FluxoAtivo: (date) => fetchFluxoAtivos(date),
        FluxoCaixa: () => fetchIFsCaixa(),
        EstatAvancada: () => fetchEstats(),
    };
    useEffect(() => {
        if (!loadedCarteiraList) {
            dispatch(fetchCarteiraList());
        }
        if (loadedCarteiraList && !isLoaded && !loading && !dispatchPDF) {
            // 20/02/2025: NÃO FUNCIONA COM O PDF ATUAL, APENAS COM O PDF QUE ACEITA LAYOUTS DA ISSUE CMDDAPP-576
            // for (const page of abas) {
            //     if (page in mapeamentoFuncoes) {
            //         dispatch(mapeamentoFuncoes[page]?.());
            //     }
            // }
            // if (preferenceCustomizacao?.ResCart_percent) dispatch(fetchResumoCartPerf());
            for (const [page, fetchPage] of Object.entries(mapeamentoFuncoes)) {
                // API de fluxo de ativos forçada a ser mes_atual quando não for chamada da própria página
                if (fluxoAtivos || page !== 'FluxoAtivo')
                    dispatch(fetchPage());
                else
                    dispatch(fetchPage('mes_atual'));
            }
            if (preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_percent)
                dispatch(fetchResumoCartPerf());
            if (!loadedCapaPDF)
                dispatch(fetchCapaPdf());
        }
    }, [loadedCarteiraList, isLoaded]);
}
export default useFechAPIs;
